import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout/index";
// Pages
import NotFoundPage from "../pages/NotFound";
import PropertyListPage from "../pages/properties/List/index.tsx";
import BudgetAnalysisPage from "../pages/budget-analysis/index.tsx";
import BudgetAnalysisGroupPage from "../pages/budget-analysis/BudgetAnalysisGroupPage.tsx";
import BudgetAnalysisSample from "../pages/budget-analysis-sample.tsx";

import PropertiesManualCreatePage from "../pages/properties/Create/index.tsx";
import PropertyDetailPage from "../pages/properties/Detail/index.tsx";
import PrivateAreaDetailPage from "../pages/properties/PrivateArea/Detail/index.tsx";
import PrivateAreaCreatePage from "../pages/properties/PrivateArea/Create/index.tsx";
import RepairDetailPage from "../pages/Repairs/Detail/detail.tsx";
import RepairCreatePage from "@/pages/Repairs/New";
import ExpenseDetailPage from "@/pages/Expenses/Detail";
import ExpenseCreatePage from "@/pages/Expenses/New";
import PaymentDetailPage from "@/pages/Payments/Detail";
import ManagementTaskDetailPage from "@/pages/ManagementTasks/Detail";
import ManagementTaskResultDetailPage from "@/pages/ManagementTaskResults/Detail";
import SystemSetting from "../pages/setting/System/index.tsx";
import EstimateListPage from "@/pages/Estimates/List/index.tsx";
import EstimateDetailPage from "@/pages/Estimates/Detail/detail.tsx";
import EmployeeUpdate from "../pages/setting/Accout/EmployeeUpdate.tsx";
import AISamplePage from "../pages/AISample";
import HomePage from "../pages/Home";
import CustomSettingPage from "../pages/setting/Custom/index.tsx";
import FiscalClosingSetting from "../pages/setting/FiscalClosing/index.tsx";
import PrivateRoute from "./PrivateRoute.tsx";
import Login from "../pages/auth/Login";
// パスワード忘れフロー(CheckMail/Otp/ChangePassword/ResetSuccess)は設定画面(ippon-client-setting)へ移設。
// ページファイルは残置(先頭にコメント)し、ここでは import/ルートを持たない。

const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Public login */}
      <Route path="/login" element={<Login />} />
      {/* パスワード忘れフロー(/checkmail, /otp, /reset-success, /reset_password)は
          設定画面(ippon-client-setting)へ移設。ログインの「お忘れの方」から設定画面FEへ遷移する。 */}
      {/* Public redirect to home by default */}
      <Route index element={<Navigate to="/home" replace />} />

      {/* Protected routes under MainLayout */}
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<MainLayout />}>
          {/* ホーム (AIチャット起点) */}
          <Route path="home" element={<HomePage />} />

          {/* 物件一覧 */}
          <Route path="properties" element={<PropertyListPage />} />
          <Route
            path="properties/create"
            element={<PropertiesManualCreatePage />}
          />

          <Route path="properties/search" element={<PropertyListPage />} />

          {/* 予実分析 */}
          <Route path="budget-analysis" element={<BudgetAnalysisPage />} />
          <Route
            path="budget-analysis/group/:groupName"
            element={<BudgetAnalysisGroupPage />}
          />
          <Route
            path="budget-analysis-sample"
            element={<BudgetAnalysisSample />}
          />

          <Route path="properties/:id" element={<PropertyDetailPage />} />
          {/* Unit 詳細 — 旧 PrivateAreaDetail を流用 (区画詳細/テナント管理/工事履歴/契約履歴) */}
          <Route
            path="properties/:propertyId/units/:privateAreaId"
            element={<PrivateAreaDetailPage />}
          />
          {/* 旧 URL の互換 (将来削除可) */}
          <Route
            path="properties/:propertyId/private-area/:privateAreaId"
            element={<PrivateAreaDetailPage />}
          />
          <Route
            path="properties/:propertyId/private-area/create"
            element={<PrivateAreaCreatePage />}
          />

          {/* エンティティ詳細ページ (Notion 風ドロワーから全画面遷移時にも使用) */}
          <Route path="repairs/new" element={<RepairCreatePage />} />
          <Route path="expenses/new" element={<ExpenseCreatePage />} />
          <Route path="expenses/:id" element={<ExpenseDetailPage />} />
          {/* 入金詳細 (PreviewDrawer 全画面遷移先) */}
          <Route path="payments/:id" element={<PaymentDetailPage />} />
          {/* 管理業務詳細 (PreviewDrawer 全画面遷移先) */}
          <Route
            path="management-tasks/:id"
            element={<ManagementTaskDetailPage />}
          />
          {/* 管理業務月別実績 (PreviewDrawer 全画面遷移先) */}
          <Route
            path="management-task-results/:task_id"
            element={<ManagementTaskResultDetailPage />}
          />
          {/* 修繕詳細 */}
          <Route path="repairs/:id" element={<RepairDetailPage />} />

          {/* 見積書管理 */}
          <Route path="estimates" element={<EstimateListPage />} />
          <Route path="estimates/:id" element={<EstimateDetailPage />} />
          {/* <Route path="estimates/create" element={<CustomerCreate />} />
          <Route path="estimates/inquiry" element={<CustomerList />} />
          <Route path="estimates/:id" element={<CustomerList />} />
          <Route path="estimates/:id/edit" element={<CustomerCreate />} /> */}

          {/* プロフィール */}
          <Route
            path="setting/accout/:employee_id"
            element={<EmployeeUpdate />}
          />
          {/* 書類設定 */}
          <Route path="setting/system" element={<SystemSetting />} />
          {/* AIサンプル */}
          <Route path="ai-sample" element={<AISamplePage />} />
          {/* カラーテーマ例: Removed to simplify theme setup */}
          {/* カスタム設定 (カスタムフォーム + カスタムプルダウン) */}
          <Route path="setting/custom" element={<CustomSettingPage />} />
          {/* 旧 URL 互換 */}
          <Route
            path="setting/custom-form"
            element={<Navigate to="/setting/custom" replace />}
          />
          {/* 決算月設定 */}
          <Route
            path="setting/fiscal-closing"
            element={<FiscalClosingSetting />}
          />
        </Route>
      </Route>

      {/* 404 fallback */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRouter;
